import DealsContainer from "./DealsContainer";

export default DealsContainer;
